import { ENVIRONMENT_DEV, ENVIRONMENT_PROD, ENVIRONMENT_UAT, } from '../environments';
const host = 'https://d5nhc6q3o19l2.cloudfront.net/';
const API_ENVIRONMENT_DEV = 'dev';
const API_ENVIRONMENT_UAT = 'test';
const API_ENVIRONMENT_PROD = 'prod';
const API_ENVIRONMENT = {
    [ENVIRONMENT_DEV]: API_ENVIRONMENT_DEV,
    [ENVIRONMENT_UAT]: API_ENVIRONMENT_UAT,
    [ENVIRONMENT_PROD]: API_ENVIRONMENT_PROD,
};
export const API_TRANSLATIONS_URL = `${host}rtr-mv/v1/${API_ENVIRONMENT[__MV_ENVIRONMENT__]}/application/`;
